import React from 'react'
import { Col, Form, Input, Row, Select, Spin } from 'antd'
import { REGION_SOURCES } from '../CoverageCommon'
import container from './container'

const RegionHotelsModal = props => {
    const { idCount, lockRegion, canCopy, $form, $props, $loading, $fieldProps } = props

    return (
        <Spin spinning={$loading}>
            <Form {...$props} colon={false} layout={'vertical'} wrapperCol={{ flex: 1 }}>
                {$form.Item({ name: 'mode' })}
                {$form.Item({ name: 'lock_region' })}
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            name={'region_id'}
                            label={'Region ID'}
                            extra={'Must exist in lst_region.'}
                            {...$fieldProps.region_id}>
                            <Input disabled={lockRegion} placeholder={'3023'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name={'supplier_code'} label={'Source'} {...$fieldProps.supplier_code}>
                            <Select>
                                {REGION_SOURCES.map(source => (
                                    <Select.Option value={source} key={source}>
                                        {source}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item
                    name={'hotel_ids'}
                    label={'Hotel IDs'}
                    extra={`${idCount} unique id(s). Separate with commas, spaces, semicolons or new lines. Hotels without a hotel_mapping_provider row are skipped.`}
                    {...$fieldProps.hotel_ids}>
                    <Input.TextArea rows={6} placeholder={'2151861, 1127594'} />
                </Form.Item>
                {canCopy ? (
                    <Form.Item
                        name={'copy_from_region_id'}
                        label={'Or copy every hotel of another region'}
                        extra={'All sources of that region are copied in under the source above.'}
                        {...$fieldProps.copy_from_region_id}>
                        <Input placeholder={'6054439'} />
                    </Form.Item>
                ) : null}
            </Form>
        </Spin>
    )
}

export default container(RegionHotelsModal)
